import React, { Component } from 'react'


import { Row, Col, ButtonToolbar } from "react-bootstrap";
import OgaTable from "../OgaTables/OgaTable";
import Loader from "../elements/loader/Loader";
import HttpClient from "../../utils/HttpClient/HttpClient";
import TopWidgetComponent from "./TopWidgetComponent";
import OgaSelect from "../elements/OgaSelect";
import { Button } from "react-bootstrap";

export default class Widget2 extends Component {

    values = [
        {
            id: 1,
            type: "Afiliados de red",
            active: "1",
            inactive: "7",
            total: "3"
        },
        {
            id: 2,
            type: "Afiliados directos",
            active: "1",
            inactive: "7",
            total: "3"
        }];

    httpClient;
    constructor(props) {
        super(props);
        this.state = {
            methods: null,
            checked: false,
            loading: false,
            loaded: false,
            values: null
        };
        this.httpClient = new HttpClient(true);
    }

    PDFReport() {
        this.requestReport('pdf');
    }

    XLSReport() {
        this.requestReport('xls');
    }

    componentWillMount() {
        this.httpClient.get("oga/widgets/team-activity")
            .then((res) => {
                console.log("oga/widgets/team-activity success", res.data);
                this.setState({ loaded: true, values: res.data })
            })
            .catch((err) => {
                console.error("oga/widgets/team-activity Error", err);
            })
    }

    requestReport(ext) {
        let queryParam = ext === 'xls' ? '?excel=true' : '';
        this.httpClient.get("oga/report/team-activity" + queryParam, { responseType: 'blob' })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'file.' + ext);
                document.body.appendChild(link);
                link.click();
            })
            .catch((err) => {
                console.error("oga/report/team-activity Error", err);
            })
    }

    render() {
        let loaded = this.state.loaded;
        return (
            <div className="widget-container w-100">
                {
                    !loaded ?
                        <div className={"w-100 centered"} style={{ minHeight: "400px" }}>
                            <Loader show={true} />
                        </div> :
                        <div>
                            <Row className="widget-container-padding">
                                <Col md={12} className={"no-padding no-margin"}>
                                    <form>

                                        <TopWidgetComponent id={this.props.id}
                                            label={this.props.name}
                                            onSelectionChange={(val, id) => this.props.onSelectionChange(val, id)}
                                            isDashboard={this.props.isDashboard} />

                                    </form>
                                </Col>
                                <Col md={12} className={"no-padding no-margin bottom-margin-8 top-margin-8"}>
                                    <ButtonToolbar className="float-right">
                                        <Button className="bg-light-secondary"
                                            onClick={() => this.PDFReport()}>PDF</Button>
                                        &nbsp;&nbsp;
                                        <Button className="bg-light-secondary"
                                            onClick={() => this.XLSReport()}>Excel</Button>
                                    </ButtonToolbar>
                                </Col>
                                <Col md={12} className={"no-padding no-margin"}>
                                    <OgaTable
                                        loading={this.state.loading}
                                        headers={["Tipo", "Activo", "Inactivo", "Total"]}
                                        properties={["type", "active", "inactive", "total"]}
                                        format={[{
                                            range: 0,
                                            parse: (v) => v === 'NETWORK_AFFILIATE' ? "Afiliados de red" : "Afiliados directos"
                                        }]}
                                        pullRight={[1, 2, 3]}
                                        values={this.state.values} />
                                </Col>
                            </Row>
                        </div>
                }

            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/Widgets/Widget2.jsx